import CouncilNewMemberList from 'routes/NewMemberAnalytics/CouncilNewMemberList/CouncilNewMemberList';

export default CouncilNewMemberList;
